<script>
import TablePage from '@/found/components/table_page';
import request from '@/found/utils/request';
import Form from './form'; // 手动抓单表单
import FormDetail from './form/components/form_detail.vue'; // 详情表单

export default {
  name: 'table-component',
  extends: TablePage,
  components: {
    Form,
    FormDetail,
  },
  data() {
    return {
      flag: false,
    };
  },
  async created() {
    await this.getConfigList('acceptance_order_list');
  },
  methods: {
    modalClick({ val, row }) {
      this.formName = '';
      this.modalName = '';
      if (val.code === 'manual_order_grabbing') {
        // 手动抓单
        this.formName = 'Form';
        this.formConfig = {
          type: val.code,
          id: row.id,
          row,
        };
        this.modalConfig.title = '手动抓单';
        this.openFull();
      } else if (val.code === 'view') {
        // 详情
        this.formName = 'FormDetail';
        this.formConfig = {
          type: val.code,
          id: row.id,
        };
        this.modalConfig.title = '订单详情';
        this.openFull();
      } else if (val.code === 'manual_match') {
        // 手动匹配
        if (this.selection.length) {
          request.post('/kms/kmsacceptanceform/manualTrans', this.selection, { headers: { functionCode: 'acceptance_order_list' } }).then((res) => {
            this.$message.success('操作成功');
            this.getList();
          });
        } else {
          this.$message('请选择数据');
        }
      }
    },
  },
};
</script>
